import { render } from "./Generador.vue?vue&type=template&id=236aa711&scoped=true"
import script from "./Generador.vue?vue&type=script&lang=js"
export * from "./Generador.vue?vue&type=script&lang=js"

import "./Generador.vue?vue&type=style&index=0&id=236aa711&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236aa711"]])

export default __exports__